import {ref} from '@vue/composition-api';
import store from '@/store/index';

const useAdministrationSanitizationPg = () => {
  // base data
  const administrationSanitizationPg = ref (null);
  const loading = ref (false);

  // methods
  const getAdministrationSanitizationPg = async () => {
    loading.value = true;
    const {data, status} = await store.dispatch ('fetchAdministrationSanitizationPg');
    loading.value = false;
    if (status != 200) return;
    administrationSanitizationPg.value = data;
    return data;
  };

  const updateAdministrationSanitizationPg = async administrationSanitizationPg => {
    loading.value = true;
    const {data, status} = await store.dispatch ('updateAdministrationSanitizationPg', administrationSanitizationPg);
    loading.value = false;
    if (status != 200 && status != 201) return;
    return data;
  };

  return {
    administrationSanitizationPg,
    loading,
    // methods
    getAdministrationSanitizationPg,
    updateAdministrationSanitizationPg,
  };
};

export default useAdministrationSanitizationPg;
